import axios from "axios";
import $ from "jquery";
import { kebabCase } from "lodash";
import { qs, qsa } from "@/utils/dom";
const Leaflet = window.L;
let countries = {};
let geoJson = null;
let selectedView = 'all';
let map;
const LayerGoogleCustom_styles = [
    {
        featureType: "all",
        elementType: "all",
        stylers: [
            {
                saturation: -96,
            },
        ],
    },
    {
        featureType: "water",
        stylers: [
            {
                saturation: -100,
            },
            {
                lightness: 73,
            },
        ],
    },
    {
        elementType: "geometry",
        stylers: [
            {
                gamma: 2.78,
            },
        ],
    },
    {
        elementType: "labels",
        stylers: [
            {
                lightness: 27,
            },
        ],
    },
    {
        featureType: "road",
        elementType: "labels",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "water",
        stylers: [
            {
                color: "#E3EAF1",
            },
            {
                visibility: "on",
            },
        ],
    },
    {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
            {
                lightness: 47,
            },
        ],
    },
    {
        featureType: "administrative.province",
        stylers: [
            {
                visibility: "off",
            },
        ],
    },
    {
        featureType: "administrative.country",
        stylers: [
            {
                gamma: 0.53,
            },
            {
                hue: "#ff8000",
            },
            {
                saturation: 58,
            },
        ],
    },
];
function LocationMap(options) {
    const that = this;
    this.options = options;
    this.polygonHasFocus = false;
    this.polygonHasFocusZoomLevel = false;
    this.featureStyles = {};
    this.featureStyles.base = {
        countryStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 1,
            fillOpacity: 1,
            fillColor: "#cccccc",
        },
        countryNonactiveStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 1,
            fillOpacity: 1,
            fillColor: "#f0f0f0",
            clickable: false,
        },
        countryHoverStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 1,
            fillOpacity: 1,
            fillColor: "#aaaaaa",
        },
        countrySelectStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 1,
            fillOpacity: 1,
            fillColor: "#aaaaaa",
        },
    };
    this.featureStyles.hover = {
        countryStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 0,
            fillOpacity: 0,
            fillColor: "#cccccc",
        },
        countryNonactiveStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 0,
            fillOpacity: 0,
            fillColor: "#f0f0f0",
            clickable: false,
        },
        countryHoverStyle: {
            color: "#ffffff",
            weight: 1,
            opacity: 0,
            fillOpacity: 0.3,
            fillColor: "#aaaaaa",
        },
        countrySelectStyle: {
            color: "#aaaaaa",
            weight: 15,
            opacity: 0.05,
            fillOpacity: 0.15,
            fillColor: "#aaaaaa",
        },
        regionStyle: {
            color: "#ea6f18",
            weight: 2,
            opacity: 1,
            fillOpacity: 0.2,
            fillColor: "#cccccc",
        },
        regionHoverStyle: {
            color: "#ea6f18",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.3,
            fillColor: "#cccccc",
        },
        regionSelectStyle: {
            color: "#ea6f18",
            weight: 2,
            opacity: 1,
            fillOpacity: 0.2,
            fillColor: "#ea6f18",
        },
    };
    this.featureStyles.current = this.featureStyles.base;
    this.tileLayer;
    this.regionMap;
    this.markerRegion;
    this.regionMaps = [];
    this.isActiveLayer = function (layer) {
        if (this.polygonHasFocus &&
            layer._leaflet_id == this.polygonHasFocus._leaflet_id) {
            return true;
        }
        return false;
    };
    this.clickCountryByID = function (countryName) {
        var layers = this.countryLayer.getLayers();
        for (var i in layers) {
            var layer = layers[i];
            if (layer.feature.properties.name == countryName) {
                if (!this.isActiveLayer(layer)) {
                    layer.fire("click");
                }
                return;
            }
        }
        if (this.polygonHasFocus) {
            this.deselectActiveFeature();
            this.map.fitBounds(this.maxBounds);
        }
        // this.updateCountryList(isoA2, this.options.clickOnCountryListContacts);
    };
    // this.selectCountryByID = function (isoA2) {
    //   var layers = this.countryLayer.getLayers();
    //   var layer;
    //   for (var i in layers) {
    //     if (layers[i].feature.properties.iso_a2 == isoA2) {
    //       if (this.isActiveLayer(layers[i])) {
    //         return;
    //       }
    //       layer = layers[i];
    //     }
    //   }
    //   this.deselectActiveFeature();
    //   if (layer) {
    //     this.selectFeatureLayer(layer);
    //   } else {
    //     this.map.fitBounds(this.maxBounds);
    //   }
    // };
    this.deselectActiveFeature = function () {
        if (this.polygonHasFocus) {
            this.resetHighlightFeatureLayer(this.polygonHasFocus);
            this.polygonHasFocus = null;
            this.info.update();
            if (this.setCountrySelectbox)
                this.setCountrySelectbox("");
        }
    };
    this.selectFeatureLayer = function (layer) {
        var isoA2 = layer.feature.properties.iso_a2;
        var bounds = layer.getBounds();
        this.deselectActiveFeature();
        this.polygonHasFocus = layer;
        this.map.fitBounds(bounds);
        this.polygonHasFocusZoomLevel = this.map.getBoundsZoom(bounds);
        this.info.update(layer.feature.properties);
        if (this.setCountrySelectbox)
            this.setCountrySelectbox(isoA2);
        if (this.options.regionsFeatures && this.options.regionsFeatures[isoA2]) {
            // if (layer.feature.properties.is_active) {
            //   layer.setStyle(this.featureStyles.current.countryStyle);
            // } else {
            //   layer.setStyle(this.featureStyles.current.countryNonactiveStyle);
            // }
            // this.showRegionMap(isoA2);
            // this.markerLayer.bringToFront();
        }
        else {
            layer.setStyle(this.featureStyles.current.countrySelectStyle);
        }
    };
    this.resetHighlightFeatureLayer = function (layer) {
        if (layer.feature.properties.is_active) {
            layer.setStyle(this.featureStyles.current.countryStyle);
        }
        else {
            layer.setStyle(this.featureStyles.current.countryNonactiveStyle);
        }
    };
    this.highlightFeatureEvent = function (e) {
        var layer = e.target;
        if (!this.polygonHasFocus ||
            (this.polygonHasFocus &&
                layer._leaflet_id != this.polygonHasFocus._leaflet_id)) {
            layer.setStyle(this.featureStyles.current.countryHoverStyle);
            this.info.update(layer.feature.properties);
        }
    };
    this.resetHighlightFeatureEvent = function (e) {
        var layer = e.target;
        if (!this.polygonHasFocus ||
            (this.polygonHasFocus &&
                layer._leaflet_id != this.polygonHasFocus._leaflet_id)) {
            this.resetHighlightFeatureLayer(layer);
        }
        if (this.polygonHasFocus) {
            this.info.update(this.polygonHasFocus.feature.properties);
        }
        else {
            this.info.update();
        }
    };
    this.clickFeatureEvent = function (e) {
        var layer = e.target;
        var countryName = layer.feature.properties.name;
        this.featureStyles.current = this.featureStyles.hover;
        if (this.options.countryCount == 1) {
            this.selectFeatureLayer(layer);
        }
        else if (this.isActiveLayer(layer) &&
            this.polygonHasFocusZoomLevel == this.map.getZoom()) {
            this.deselectActiveFeature();
            this.map.fitBounds(this.maxBounds);
            if (this.clearCountryList)
                this.clearCountryList();
        }
        else {
            this.selectFeatureLayer(layer);
        }
        $('[name="filter-country"]').val(countryName).trigger("change");
        Location.getBranches(countryName);
        let top = $(".section-branches").offset().top;
        let headerHeight = $(".site-header .navbar").outerHeight(true);
        window.scrollTo(0, top - headerHeight);
    };
    this.onZoomEnd = function () {
        let zoomLevel = that.map.getZoom();
        if (zoomLevel > 1 && (zoomLevel >= 3 || that.options.countryCount == 1)) {
            that.featureStyles.current = that.featureStyles.hover;
        }
        else if (zoomLevel < 3) {
            that.featureStyles.current = that.featureStyles.base;
        }
        if (zoomLevel > 1 && (zoomLevel >= 3 || that.options.countryCount == 1)) {
            that.map.addLayer(that.tileLayer);
        }
        else {
            that.map.removeLayer(that.tileLayer);
            that.map.addLayer(that.countryLayer);
        }
        that.countryLayer.eachLayer(function (layer) {
            if (layer.feature.properties.is_active) {
                if (that.polygonHasFocus &&
                    layer._leaflet_id == that.polygonHasFocus._leaflet_id) {
                    layer.setStyle(that.featureStyles.current.countrySelectStyle);
                }
                else if (!that.polygonHasFocus ||
                    (that.polygonHasFocus &&
                        layer._leaflet_id != that.polygonHasFocus._leaflet_id)) {
                    layer.setStyle(that.featureStyles.current.countryStyle);
                }
            }
            else {
                layer.setStyle(that.featureStyles.current.countryNonactiveStyle);
            }
        });
        that.markerLayer.bringToFront();
        if (zoomLevel > 1 && (zoomLevel >= 3 || that.options.countryCount == 1)) {
            that.markerLayer.eachLayer(function (marker) {
                marker.options.clickable = true;
                if (marker._path) {
                    var container = marker._path;
                }
                else {
                    var container = marker._container;
                }
                Leaflet.DomUtil.addClass(container, "leaflet-clickable");
                Leaflet.DomUtil.removeClass(container, "leaflet-nonclickable");
                container.style["visibility"] = "visible";
            });
        }
        else {
            that.markerLayer.eachLayer(function (marker) {
                marker.options.clickable = false;
                if (marker._path) {
                    var container = marker._path;
                }
                else {
                    var container = marker._container;
                }
                Leaflet.DomUtil.addClass(container, "leaflet-nonclickable");
                Leaflet.DomUtil.removeClass(container, "leaflet-clickable");
                if (that.options.consultantTypeOnWorldmap[marker.options.locationType]) {
                    container.style["visibility"] = "visible";
                }
                else {
                    container.style["visibility"] = "hidden";
                }
            });
        }
    };
    this.initializeMap = function (divId) {
        var that = this;
        var southWest = new Leaflet.LatLng(-58.64489630449362, -201.42370526861555, true), northEast = new Leaflet.LatLng(81.29351994784489, 220.9293414555197, true);
        var southWest = new Leaflet.LatLng(-74.37648114088306, -202.03581113343313, true), northEast = new Leaflet.LatLng(86.40711375464741, 220.31723559070215, true);
        this.maxBounds = new Leaflet.LatLngBounds(southWest, northEast);
        var minZoom = 2;
        this.map = Leaflet.map(divId, {
            attributionControl: false,
            minZoom: minZoom,
            maxZoom: 7,
            scrollwheel: false,
            zoomControl: true,
            // dragging: !Leaflet.Browser.mobile,
            dragging: true,
            tap: !Leaflet.Browser.mobile,
        }).setView([35, 10], minZoom);
        this.map.scrollWheelZoom.disable();
        this.countriesBounds = new Leaflet.LatLngBounds();
        // this.franceBounds = new Leaflet.LatLngBounds([
        //   [41, -8],
        //   [52, 14],
        // ]);
        var onEachFeature = function (feature, layer) {
            if (layer.feature.properties.is_active) {
                // if (layer.feature.properties.iso_a2 == "FR") {
                //   that.countriesBounds.extend(that.franceBounds);
                // } else {
                that.countriesBounds.extend(layer.getBounds());
                // }
                layer.on({
                    mouseover: $.proxy(that.highlightFeatureEvent, that),
                    mouseout: $.proxy(that.resetHighlightFeatureEvent, that),
                    click: $.proxy(that.clickFeatureEvent, that),
                });
            }
            else {
                layer.setStyle(that.featureStyles.current.countryNonactiveStyle);
            }
        };
        this.countryLayer = Leaflet.geoJson(geoJson, {
            style: this.featureStyles.current.countryStyle,
            onEachFeature: onEachFeature,
        });
        this.tileLayer = new Leaflet.Google("ROADMAP", {
            styles: LayerGoogleCustom_styles,
        });
        this.markerLayer = Leaflet.featureGroup();
    };
    this.extendMap = function (callbackFunc) {
        callbackFunc.call(this);
    };
    this.startMap = function () {
        var that = this;
        this.map.addLayer(this.countryLayer);
        this.map.addLayer(this.markerLayer);
        this.markerLayer.eachLayer(function (marker) {
            marker.options.clickable = false;
            if (marker._path) {
                var container = marker._path;
            }
            else {
                var container = marker._container;
            }
            Leaflet.DomUtil.addClass(container, "leaflet-nonclickable");
            Leaflet.DomUtil.removeClass(container, "leaflet-clickable");
            if (that.options.consultantTypeOnWorldmap[marker.options.locationType]) {
                container.style["visibility"] = "visible";
            }
            else {
                container.style["visibility"] = "hidden";
            }
        });
        var InfoControl = Leaflet.Control.extend({
            options: {
                position: "topright",
            },
            onAdd: function (map) {
                this._div = Leaflet.DomUtil.create("div", "info");
                this.update();
                return this._div;
            },
            update: function (props) {
                if (props && countries[props["iso_a2"]]) {
                    this._div.innerHTML = countries[props["iso_a2"]];
                    this._div.style.display = "block";
                }
                else {
                    this._div.innerHTML = "";
                    this._div.style.display = "none";
                }
            },
        });
        this.info = new InfoControl();
        this.map.addControl(this.info);
        this.map.on("zoomend", this.onZoomEnd);
        if (this.options.countryCount > 0 && this.options.countryCount < 50) {
            this.map.fitBounds(this.countriesBounds, {
                animate: false,
            });
            this.map.setZoom(3);
            this.map.panTo({ lat: 0.026337726064666, lng: 101.64947687468008 });
            this.map.setMaxBounds(this.map.getBounds().pad(0.4));
            this.maxBounds = this.map.getBounds().pad(-0.4);
        }
        this.markerLayer.bringToFront();
    };
}
const Location = {
    init: async () => {
        const $gmap = document.getElementById("gmap");
        if ($gmap) {
            await Location.getGeoJson($gmap);
            await Location.getCountries($gmap);
            Location.appendCountries();
            Location.initLocationMap($gmap);
        }
    },
    initLocationMap: ($gmap) => {
        const $sectionMap = document.querySelector(".section-map");
        const $navLinks = $sectionMap.querySelectorAll(".nav-link");
        const dataset = $gmap.dataset;
        const markers = JSON.parse(dataset.marker);
        const options = JSON.parse(dataset.options);
        const map = new LocationMap(options);
        map.initializeMap($gmap);
        map.extendMap(function () {
            for (var i = 0, max = markers.length; i < max; i++) {
                let markerItem = markers[i];
                let color = "#ea6f18";
                if (markers[i].type === "DISTRIBUTOR") {
                    color = "#000000";
                }
                this.markerLayer.addLayer(Leaflet.circle([markerItem["coord"]["lat"], markerItem["coord"]["lng"]], 40000, {
                    color,
                    branchId: markerItem.id,
                    fillColor: markerItem.fillColor,
                    locationType: 1,
                    clickable: true,
                    weight: 0,
                    fillOpacity: 1,
                    label: markerItem.label,
                    type: markers[i].type,
                })
                    .bindLabel(markerItem.label)
                    .addTo(this.map)
                    .on("click", (event) => {
                    const branchId = event.target.options.branchId;
                    Location.getBranch(branchId);
                }));
            }
        });
        map.startMap();
        // @ts-ignore
        $('[name="filter-country"]').on("select2:select", (event) => {
            const { value } = event.target;
            map.clickCountryByID(value);
        });
        $navLinks.forEach((navLink) => {
            navLink.addEventListener("click", (event) => {
                const slug = navLink.getAttribute("data-slug");
                event.preventDefault;
                if (navLink.classList.contains("active"))
                    return;
                $navLinks.forEach((navLink) => {
                    navLink.classList.remove("active");
                });
                navLink.classList.add("active");
                selectedView = slug;
                Location.toggleBranch(selectedView, map);
                switch (selectedView) {
                    case "all":
                        map.markerLayer.eachLayer((marker) => {
                            marker.setStyle({
                                fillOpacity: 1,
                                clickable: true,
                            })
                                .bindLabel(marker.options.label);
                        });
                        break;
                    case "regional":
                        map.markerLayer.eachLayer((marker) => {
                            if (marker.options.type !== "REGIONAL_OFFICE") {
                                marker.setStyle({
                                    fillOpacity: 0,
                                }).unbindLabel();
                            }
                            else {
                                marker.setStyle({
                                    fillOpacity: 1,
                                }).bindLabel(marker.options.label);
                            }
                        });
                        break;
                    case "distributor":
                        map.markerLayer.eachLayer((marker) => {
                            if (marker.options.type === "REGIONAL_OFFICE") {
                                marker.setStyle({
                                    fillOpacity: 0,
                                    clickable: false,
                                }).unbindLabel();
                            }
                            else {
                                marker.setStyle({
                                    fillOpacity: 1,
                                    clickable: true,
                                }).bindLabel(marker.options.label);
                            }
                        });
                        break;
                }
            });
        });
    },
    getGeoJson: async ($gmap) => {
        const dataset = $gmap.dataset;
        const options = JSON.parse(dataset.options);
        const { data } = await axios(`/api/directories/geojson`);
        geoJson = data;
        geoJson.features.forEach((item) => {
            for (let name in options.countryNames) {
                if (item.properties.iso_a2 === name) {
                    item.properties["is_active"] = true;
                }
            }
        });
    },
    getCountries: async ($gmap) => {
        const dataset = $gmap.dataset;
        const options = JSON.parse(dataset.options);
        const { data } = await axios(`/api/countries`);
        for (let item in data) {
            for (let countryName in options.countryNames) {
                if (item === countryName) {
                    countries[item] = data[item];
                }
            }
        }
    },
    appendCountries: () => {
        let option = "";
        var sortedCountries = [];
        for (var vehicle in countries) {
            sortedCountries.push([vehicle, countries[vehicle]]);
        }
        sortedCountries.sort(function (a, b) {
            return a[1] - b[1];
        });
        sortedCountries.forEach((country) => {
            option += `<option value="${country[1]}">${country[1]}</option>`;
        });
        $('[name="filter-country"]').append(option).trigger("change");
    },
    getBranch: async (branchId) => {
        const { data } = await axios(`/api/directories/branches?id=${branchId}`);
        const $sectionBranches = qs(".section-branches");
        let top = $(".section-branches").offset().top;
        let headerHeight = $(".site-header .navbar").outerHeight(true);
        window.scrollTo(0, top - headerHeight);
        $('[name="filter-country"]').val(data.data.country.name).trigger("change");
        $sectionBranches.innerHTML = data.rendered;
        Location.toggleBranch(selectedView, map);
    },
    getBranches: async (countryName) => {
        const $sectionBranches = qs(".section-branches");
        const { data } = await axios(`/api/directories/branches/${kebabCase(countryName)}`);
        $sectionBranches.innerHTML = data.rendered;
        Location.toggleBranch(selectedView, map);
    },
    toggleBranch: (selectedView, map) => {
        const $sectionBranches = qs(".section-branches");
        const $regionals = qsa(".is-regional", $sectionBranches);
        const $distributors = qsa(".is-distributor", $sectionBranches);
        const $regionalBorder = qs(".is-regional-border", $sectionBranches);
        const $distributorBorder = qs(".is-distributor-border", $sectionBranches);
        switch (selectedView) {
            case "all":
                if ($regionalBorder) {
                    $regionalBorder.classList.remove('d-none');
                }
                if ($distributorBorder) {
                    $distributorBorder.classList.remove('d-none');
                }
                $distributors.forEach(($distributor) => {
                    $distributor.classList.remove("d-none");
                });
                $regionals.forEach(($regional) => {
                    $regional.classList.remove('d-none');
                });
                break;
            case "regional":
                if ($regionalBorder) {
                    if ($regionalBorder.nextElementSibling &&
                        $regionalBorder.nextElementSibling.classList.contains('is-business-unit')) {
                        $regionalBorder.classList.remove('d-none');
                    }
                    else {
                        $regionalBorder.classList.add('d-none');
                    }
                }
                if ($distributorBorder) {
                    $distributorBorder.classList.add('d-none');
                }
                $distributors.forEach(($distributor) => {
                    $distributor.classList.add("d-none");
                });
                $regionals.forEach(($regional) => {
                    $regional.classList.remove('d-none');
                });
                break;
            case "distributor":
                if ($regionalBorder) {
                    $regionalBorder.classList.add('d-none');
                }
                if ($distributorBorder) {
                    if ($distributorBorder.previousElementSibling &&
                        $distributorBorder.previousElementSibling.classList.contains('is-business-unit')) {
                        $distributorBorder.classList.remove('d-none');
                    }
                    else {
                        $distributorBorder.classList.add('d-none');
                    }
                }
                $distributors.forEach(($distributor) => {
                    $distributor.classList.remove("d-none");
                });
                $regionals.forEach(($regional) => {
                    $regional.classList.add('d-none');
                });
                break;
        }
    }
};
export default Location;
